import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

import {
    CreateAndEditGenreModalProps
} from "./models";

import { t, Trans } from "@lingui/macro";
import { ZPlayFormField } from "commons/fields";
import * as Yup from "yup";
import { withUseFormHook, } from "@sinossi/mates-react-library";
import {ContentProducerService} from "services/content-producer-service";
import {CreateGenreRequest, EditGenreRequest} from "models/request";


const CreateAndEditGenreModalSchema = Yup.object().shape({
    name: Yup.string().required(t({
        id: "caegm-name-required-msg",
        message: "È necessario inserire un nome per poter modificare il genere"
    })),
});

class CreateAndEditGenreModal extends React.Component<CreateAndEditGenreModalProps & UseFormReturn, {}>
{

    componentDidMount(){
        if(this.props.genre){
            this.props.setValue("name", this.props.genre.value);
        }
    }

    private getValues = () => {
        let value = this.props.getValues("name")
        if(this.props.genre){
            this.editGenre(value);
        } else {
            this.createGenre(value);
        }
    }

    private editGenre = (values: any) => {

        let request: EditGenreRequest = {
            value: values
        }

        ContentProducerService.editGenre(this.props.genre!.id, request, this.props.editGenreCallback, this.props.editGenreErrorCallback)
    }

    private createGenre = (values: any) => {

        let request: CreateGenreRequest = {
            value: values
        }

        ContentProducerService.createGenre(request, this.props.createGenreCallback, this.props.createGenreErrorCallback);
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                color={process.env.REACT_APP_BACKGROUND_COLOR}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {this.props.genre? <Trans id="caegm-edit-title">Modifica genere</Trans> : <Trans id="caegm-create-title">Aggiungi genere</Trans>}
                </DialogTitle>
                <form>
                    <DialogContent>
                        <Typography mt={-2}>
                            <Trans id="caegm-genre-name-label">Inserisci un genere</Trans>
                        </Typography>
                        <ZPlayFormField
                            label={t({
                                id: "caegm-name",
                                message: "Genere"
                            })}
                            name="name"
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.closeModal}>
                            <Trans id={"caegm-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="button"
                            disabled={this.props.formState.isSubmitting}
                            onClick={this.getValues}
                        >
                            {this.props.genre? <Trans id={"caegm-edit-btn"}>Modifica</Trans> : <Trans id={"caegm-create-btn"}>Aggiungi</Trans>}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withUseFormHook<{}>(CreateAndEditGenreModal, CreateAndEditGenreModalSchema, {});
